import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { inject, observer, PropTypes as mobxPropTypes } from 'mobx-react';
import { REPORTS_TYPES_LIST } from '../../constants/reports';
import { ROLE_PHYSICIAN, ROLE_SALES } from '../../constants/roles';
import Form from '../../components/Form/Form';


const propTypes = {
  userStore: mobxPropTypes.observableObject.isRequired,
  reportStore: mobxPropTypes.observableObject.isRequired,
  history: PropTypes.oneOfType([PropTypes.object]).isRequired,
  userId: PropTypes.number,
};

const defaultProps = {
  userId: null,
};

class AddReportForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userList: [],
      defaultUser: null,
    };
    this.handleAutoComplete = this.handleAutoComplete.bind(this);
  }

  componentWillMount() {
    const { userId } = this.props;
    this.fetchInitialData();
    if (userId !== null) {
      this.setDefaultUser(userId);
    }
  }

  async setDefaultUser(userId) {
    const { userStore } = this.props;
    const { userList } = this.state;
    const id = parseInt(userId, 10);
    const response = await userStore.api.users.get({ id });
    let defaultUser = null;
    if (response && (response.role === ROLE_PHYSICIAN || response.role === ROLE_SALES)) {
      defaultUser = {
        value: response.id,
        label: response.full_name,
      };
      userList.push(defaultUser);
      this.setState({ userList, defaultUser });
    }
  }

  async fetchUsers(searchParams) {
    const { userStore } = this.props;
    const defaultParams = {
      role__in: `${ROLE_PHYSICIAN},${ROLE_SALES}`,
      order_by: 'first_name',
    };
    const params = Object.assign(searchParams, defaultParams);
    const response = await userStore.api.users.get({ params });
    let results = [];
    if (response && response.objects) {
      results = response.objects.map(user => ({
        value: user.id,
        label: user.full_name,
      }));
    }
    return results;
  }

  async fetchInitialData() {
    const userList = await this.fetchUsers({ limit: 5 });
    this.setState({ userList });
  }

  async handleAutoComplete(input) {
    if (!input) {
      return Promise.resolve([]);
    }
    const userList = await this.fetchUsers({ full_name: input });
    return Promise.resolve(userList);
  }

  render() {
    const { reportStore, history } = this.props;
    const { userList, defaultUser } = this.state;
    const fields = [
      {
        id: 'title',
        name: 'title',
        label: 'Title',
        type: 'text',
        validateAs: 'string',
        defaultVal: '',
        required: true,
      },
      {
        id: 'assignTo',
        name: 'assignTo',
        label: 'Assign To',
        type: 'autocomplete',
        validateAs: 'number',
        defaultVal: '',
        required: true,
        customProps: {
          defaultOptions: userList,
          defaultSelected: defaultUser,
          loadOptions: this.handleAutoComplete,
          disabled: defaultUser !== null,
        },
      },
      {
        id: 'document',
        name: 'document',
        label: 'Upload Report',
        type: 'upload',
        validateAs: 'mixed',
        defaultVal: '',
        required: true,
      },
      {
        id: 'type',
        name: 'type',
        label: 'Type',
        type: 'select',
        placeholder: 'Select a report type',
        validateAs: 'number',
        defaultVal: '',
        required: true,
        customProps: {
          inputProps: {
            name: 'type',
            id: 'type',
          },
          data: REPORTS_TYPES_LIST,
        },
      },
    ];
    return (
      <Form
        fields={fields}
        onSubmit={async (values, { setSubmitting }) => {
          try {
            await reportStore.create(values);
            history.push('/reports');
          } catch (error) {
            setSubmitting(false);
          }
        }}
        submitLabel="Submit"
        columns={2}
        spacing={32}
      />
    );
  }
}

AddReportForm.propTypes = propTypes;
AddReportForm.defaultProps = defaultProps;

const AddReportFormInjected = inject('userStore', 'reportStore')(observer(AddReportForm));
export default withRouter(AddReportFormInjected);



// WEBPACK FOOTER //
// ./src/containers/ReportAddForm/ReportAddForm.js